export const API_KEY = "AIzaSyCttBd2B_N43s4g0B-SNnncg91_u2pqfRA"
